module.exports = __webpack_public_path__ + "img/avatar-icon.5a24a93c.svg";